import { NpssPostTemplateTagsQuery } from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import GET_NPSS_POST_TEMPLATE_TAGS from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/npss/npssPostTemplateTags.graphql';
import { useQuery } from '@apollo/client';

export const useNpssPostTemplateTags = () =>
  useQuery<NpssPostTemplateTagsQuery>(GET_NPSS_POST_TEMPLATE_TAGS, {});
